(function () {
  function normalizeBrand(value) {
    var normalized = String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (normalized === 'ducio-di-segna') normalized = 'duccio-di-segna';
    return normalized;
  }

  function brandsMatch(a, b) {
    if (!a || !b) return false;
    var left = normalizeBrand(a);
    var right = normalizeBrand(b);
    return left === right || left.indexOf(right) !== -1 || right.indexOf(left) !== -1;
  }

  function initBrandTabs() {
    var brandTabs = document.querySelector('.new-collection-tabs--brand');
    if (!brandTabs || brandTabs.dataset.brandTabsReady === 'true') return;

    var collectionListSection = document.querySelector('[data-collection-list-section]');
    var collectionListRoot = collectionListSection
      ? collectionListSection.querySelector('.collection-list__results .resource-list')
      : null;
    var originalCollectionItems = collectionListRoot
      ? Array.prototype.slice.call(collectionListRoot.querySelectorAll('.resource-list__item'))
      : Array.prototype.slice.call(
          document.querySelectorAll('[data-collection-list-section] .resource-list__item')
        );

    function getBrandFacetContext() {
      var forms = Array.prototype.slice.call(document.querySelectorAll('facets-form-component'));
      var facetsForm = forms.find(function (form) {
        return !form.closest('dialog');
      });
      if (!facetsForm) return null;

      var inputs = Array.prototype.slice.call(
        facetsForm.querySelectorAll('input[type="checkbox"][name^="filter."]')
      ).filter(function (input) {
        return input.name.toLowerCase().indexOf('brand') !== -1;
      });

      return inputs.length ? { facetsForm: facetsForm, inputs: inputs } : null;
    }

    var usesCollectionCards = originalCollectionItems.length > 0;
    if (!usesCollectionCards && !getBrandFacetContext()) return;
    brandTabs.dataset.brandTabsReady = 'true';

    var allTab = brandTabs.querySelector('[data-brand-all="true"]');
    var collectionItems = originalCollectionItems.filter(function (item) {
      return item.hasAttribute('data-brand');
    });
    var initialBrandParam = normalizeBrand(new URLSearchParams(window.location.search).get('brand'));

    function scrollTabIntoContainer(tab) {
      var container = brandTabs.querySelector('.new-collection-tabs__container');
      if (!tab || !container) return;
      var isRtl = getComputedStyle(container).direction === 'rtl';
      tab.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: isRtl ? 'start' : 'nearest',
      });
    }

    function setActiveBrandTab(activeTab) {
      var tabs = brandTabs.querySelectorAll('.new-collection-tabs__item');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.classList.remove('new-collection-tabs__item--active');
        tab.dataset.isActive = 'false';
      });
      if (activeTab) {
        activeTab.style.display = '';
        activeTab.classList.add('new-collection-tabs__item--active');
        activeTab.dataset.isActive = 'true';
        scrollTabIntoContainer(activeTab);
      }
    }

    function updateBrandUrl(brandHandle) {
      var url = new URL(window.location.href);
      if (!brandHandle) {
        url.searchParams.delete('brand');
      } else {
        url.searchParams.set('brand', brandHandle);
      }
      window.history.replaceState({}, '', url);
    }

    function findTabForBrand(brandHandle) {
      if (!brandHandle) return allTab;
      var normalized = normalizeBrand(brandHandle);
      var match = null;
      var tabs = brandTabs.querySelectorAll('.new-collection-tabs__item[data-brand-handle]');
      Array.prototype.forEach.call(tabs, function (tab) {
        if (tab.dataset.brandAll === 'true') return;
        if (brandsMatch(normalizeBrand(tab.dataset.brandHandle), normalized)) match = tab;
      });
      if (match) match.style.display = '';
      return match;
    }

    function getSelectedFacetBrand() {
      var context = getBrandFacetContext();
      if (!context) return '';

      var url = new URL(window.location.href);
      var selectedValues = [];
      context.inputs.forEach(function (input) {
        url.searchParams.getAll(input.name).forEach(function (value) {
          if (selectedValues.indexOf(value) === -1) selectedValues.push(value);
        });
      });

      return selectedValues.length === 1 ? normalizeBrand(selectedValues[0]) : '';
    }

    function syncFacetBrandTab() {
      var context = getBrandFacetContext();
      if (!context) return;

      var selectedBrand = getSelectedFacetBrand();
      if (!selectedBrand) {
        setActiveBrandTab(allTab);
        return;
      }

      setActiveBrandTab(findTabForBrand(selectedBrand));
    }

    function applyFacetBrandSelection(brandHandle) {
      var context = getBrandFacetContext();
      if (!context) return;

      var requestedBrand = normalizeBrand(brandHandle);
      var matchingInput = requestedBrand
        ? context.inputs.find(function (input) {
            return brandsMatch(input.value, requestedBrand);
          })
        : null;
      var url = new URL(window.location.href);

      context.inputs.forEach(function (input) {
        url.searchParams.delete(input.name);
      });
      url.searchParams.delete('brand');
      url.searchParams.delete('page');

      if (matchingInput) {
        url.searchParams.append(matchingInput.name, matchingInput.value);
        setActiveBrandTab(findTabForBrand(requestedBrand));
      } else {
        setActiveBrandTab(allTab);
      }

      if (typeof context.facetsForm.updateFiltersByURL === 'function') {
        context.facetsForm.updateFiltersByURL(url.toString());
      } else {
        window.location.href = url.toString();
      }
    }

    function filterCollectionItems(brandHandle) {
      if (!originalCollectionItems.length) return 0;
      var normalized = normalizeBrand(brandHandle);
      var visibleCount = 0;

      originalCollectionItems.forEach(function (item) {
        if (!normalized) {
          item.classList.remove('is-brand-filter-hidden');
          item.hidden = false;
          visibleCount += 1;
          return;
        }

        var visible = itemMatchesBrand(item, normalized);
        item.classList.toggle('is-brand-filter-hidden', !visible);
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      return visibleCount;
    }

    function showAllBrandTabs() {
      var tabs = brandTabs.querySelectorAll('.new-collection-tabs__item');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.style.display = '';
      });
    }

    function itemMatchesBrand(item, normalized) {
      if (!normalized) return true;
      var itemBrand = normalizeBrand(item.dataset.brand || item.getAttribute('data-brand'));
      if (itemBrand && brandsMatch(itemBrand, normalized)) return true;

      var link = item.querySelector('a[href*="/collections/"]');
      var href = link ? link.getAttribute('href') || '' : '';
      var hrefHandle = normalizeBrand((href.split('/collections/')[1] || '').split('?')[0]);
      if (hrefHandle && brandsMatch(hrefHandle, normalized)) return true;

      return false;
    }

    function applyBrandSelection(brandHandle) {
      if (!usesCollectionCards) {
        applyFacetBrandSelection(brandHandle);
        return;
      }

      var requestedHandle = normalizeBrand(brandHandle);

      if (!requestedHandle) {
        setActiveBrandTab(allTab);
        filterCollectionItems('');
        updateBrandUrl('');
        showAllBrandTabs();
        return;
      }

      var activeTab = findTabForBrand(requestedHandle);
      var resolvedHandle = activeTab ? normalizeBrand(activeTab.dataset.brandHandle) : requestedHandle;
      var visibleCount = filterCollectionItems(resolvedHandle);

      if (visibleCount === 0) {
        var brandUrl = activeTab && (activeTab.getAttribute('data-brand-url') || '');
        if (brandUrl) {
          window.location.assign(brandUrl);
          return;
        }
        setActiveBrandTab(allTab);
        filterCollectionItems('');
        updateBrandUrl('');
        showAllBrandTabs();
        return;
      }

      if (activeTab) {
        setActiveBrandTab(activeTab);
      } else {
        setActiveBrandTab(null);
      }
      updateBrandUrl(resolvedHandle);
      showAllBrandTabs();
    }

    brandTabs.addEventListener('click', function (e) {
      var tab = e.target.closest('.new-collection-tabs__item');
      if (!tab || tab.style.display === 'none') return;

      e.preventDefault();
      e.stopPropagation();

      var nextBrand =
        tab.dataset.brandAll === 'true' || tab.dataset.isActive === 'true' ? '' : tab.dataset.brandHandle;
      applyBrandSelection(nextBrand || '');
    });

    if (usesCollectionCards) {
      applyBrandSelection(initialBrandParam || '');
    } else {
      syncFacetBrandTab();
      document.addEventListener('filter:update', function () {
        window.requestAnimationFrame(syncFacetBrandTab);
      });
    }

    window.addEventListener('popstate', function () {
      if (!usesCollectionCards) {
        window.requestAnimationFrame(syncFacetBrandTab);
        return;
      }
      var nextBrand = new URLSearchParams(window.location.search).get('brand');
      applyBrandSelection(nextBrand || '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandTabs);
  } else {
    initBrandTabs();
  }

  document.addEventListener('shopify:section:load', initBrandTabs);
})();
